import { apiClient } from '@/api/client';

/**
 * Geography reference-data API surface (MYN-46). Country/State are small
 * enough (250 / 5,308 rows) to fetch in full and filter client-side; City is
 * search-backed (152,970 rows worldwide, up to ~1,757 in one state).
 */
export interface Country {
  id: number;
  name: string;
  iso2: string;
  /** Business-classification bucket (WORLD_REGIONS), not the raw dataset region. */
  worldRegion: string | null;
}

export interface StateOption {
  id: number;
  name: string;
  countryId: number;
}

export interface CityOption {
  id: number;
  name: string;
}

export async function fetchCountries(): Promise<Country[]> {
  const { data } = await apiClient.get<Country[]>('/geography/countries');
  return data;
}

export async function fetchStates(): Promise<StateOption[]> {
  const { data } = await apiClient.get<StateOption[]>('/geography/states');
  return data;
}

export async function searchCities(stateId: number, search: string): Promise<CityOption[]> {
  const { data } = await apiClient.get<CityOption[]>(`/geography/states/${stateId}/cities`, {
    params: search ? { search } : undefined,
  });
  return data;
}

/**
 * City search within one country, for non-US headquarters where State is not
 * asked (UX sheet r105). Same item shape and `search` param as `searchCities`;
 * the Backend derives the state from the chosen city on save.
 */
export async function searchCitiesByCountry(
  countryId: number,
  search: string,
): Promise<CityOption[]> {
  const { data } = await apiClient.get<CityOption[]>(`/geography/countries/${countryId}/cities`, {
    params: search ? { search } : undefined,
  });
  return data;
}
